import React from 'react';
import { createMuiTheme, makeStyles, MuiThemeProvider } from "@material-ui/core";
import About from "./components/About";
import Contact from "./components/Contact";
import Myworks from "./components/Myworks";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import { Parallax, ParallaxLayer } from '@react-spring/parallax'
import './App.css'

const theme = createMuiTheme({
  pallete:{
    primary: {main: "#DD965D"},
    secondary: {main:'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'}
  }
})

function App() {
  const classes = useStyles();
  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
        <Parallax pages={3} scrolling={true}>
        <ParallaxLayer offset={0} speed={0.2} height='100vh'>
        <Navbar />

        <About title="GLEZART" id="inicio" className={classes.inicio}/>
        </ParallaxLayer>
        <ParallaxLayer offset={0.999} speed={0.5} factor={0}>

        <Myworks title="WORK" id="work" dark={false }/>
        <Skills title="INFORMATION" id="information" dark={false }/>
        <Contact title="CONTACT" id="contact" dark={false }/>
        </ParallaxLayer>

     </Parallax>
      </div>
    </MuiThemeProvider>
    
  );
}
const useStyles = makeStyles((theme)=>({
  root:{
    height:'100%'
  }
}))

export default App;
